<style scoped>
    @import url("../../styles/mainV2/itemCarousel.scss");
</style>

<template>
    <div class="box_itemCarousel">

        <div 
        class="div_carousel"
        v-for="(item,i) in liLocalItems"
        :key="i"
        :visibleSlide="visibleSlide"
        v-show="visibleSlide == i"
        >
            <!-- LARGE -->
            <img 
            @click="next()" 
            class='hidden-sm-and-down imgs_carousel animate__animated animate__fadeIn custom-duration'
            :src="item.imgL"
            />

            <!-- SMALL 23/05/2025 -->
            <img 
            @click="next()" 
            class='hidden-md-and-up imgs_carousel animate__animated animate__fadeIn custom-duration'
            :src="item.imgS"
            />

            <!-- action v2 05/05/2025 -->
            <div class="slidePainel">

                <!-- coluna left -->
                <div class="colActionL"
                @mouseover="onChange('on')"
                @mouseleave="onChange()"
                :style="{'background':backColorArrowL}"
                @click="before()" 
                >
                    <v-icon size="36" :style="{'color':colorArrowL}">mdi-arrow-left-thick</v-icon>
                </div>

                <!-- coluna right -->
                <div class="colAction"
                @mouseover="onChange('on','right')"
                @mouseleave="onChange('off','right')"
                :style="{'background':backColorArrow}"
                @click="next()" 
                >
                    <v-icon size="36" :style="{'color':colorArrow}">mdi-arrow-right-thick</v-icon>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
export default {

    //props:['liItemsToShow'],

    data() {
        return {
            timer: null,
            polling: null,
            lista_carousel: null,
            //classNext:'', // aux transição aniamda.

            pararCarousel: false, // parar carousel com scroll.
            visibleSlide: 0, // posição da lista de imagens carousel.
            item_escolhido: 0, // item da lista carousel ao chamar a aux page.
            aux_index: 0,
            liLocalItems: [
                {
                    imgS:require('../../assets/carousel/v3/c1s.png'),
                    imgL:require('../../assets/carousel/v3/c1.png'),
                    //txt1:'Produto promocional',
                },
                /*{
                    imgS:require('../../assets/carousel/v2/c1s.png'),
                    imgL:require('../../assets/carousel/v2/c1.png'),
                    txt1:'O seu clube na Covilhã',
                },*/
                {
                    imgS:require('../../assets/carousel/v3/c2s.png'),
                    imgL:require('../../assets/carousel/v3/c2.png'),
                    txt1:'Produto promocional',
                },
                {
                    imgS:require('../../assets/carousel/v3/c3s.png'),
                    imgL:require('../../assets/carousel/v3/c3.png'),
                    txt1:'Produto promocional',
                }
            ],

            flagSaberMais:false,

            // btn slide
            backColorArrowL:'', // left
            colorArrowL:'', // left
            backColorArrow:'', // right
            colorArrow:'', // right
        }
    },
    methods: {
        onChange(flag, flagCol) {

            if (flagCol == 'right') {
                if (flag == 'on') { 
                    this.backColorArrow = 'rgba(255,255,255,0.1)'
                    this.colorArrow = '#f39c12'
                } else {
                    this.backColorArrow = ''
                    this.colorArrow = ''
                }
            } else {
                if (flag == 'on') { 
                    this.backColorArrowL = 'rgba(255,255,255,0.1)'
                    this.colorArrowL = '#f39c12'
                } else {
                    this.backColorArrowL = ''
                    this.colorArrowL = ''
                }
            }
        },
        next() {

            if(this.visibleSlide >= this.liLocalItems.length - 1) {
                //this.classNext = 'imgs_carousel animate__animated animate__slideInRight'
                this.visibleSlide = 0 // RESET
            }
            else {
                //this.classNext = 'imgs_carousel animate__animated animate__slideInRight'
                this.visibleSlide++
            }
        },
        before() {

            if(this.visibleSlide == 0) {
                //this.classNext = 'imgs_carousel animate__animated animate__slideInRight'
                this.visibleSlide = this.liLocalItems.length - 1 // RESET
            }
            else {
                //this.classNext = 'imgs_carousel animate__animated animate__slideInRight'
                this.visibleSlide--
            }
        },
        contadorCarousel() {
            
            this.polling = window.setInterval(() => {

                if (this.pararCarousel == true) {

                    this.aux_index = this.visibleSlide
                    this.visibleSlide = this.aux_index // STOP
                }

                else { // Keep on

                    if(this.visibleSlide >= this.liLocalItems.length - 1) {
                    
                        //this.classNext = 'imgs_carousel animate__animated animate__slideInRight'
                        this.visibleSlide = 0 // RESET fim de percurso.
                    }
                    else {
                        
                        //this.classNext = 'imgs_carousel animate__animated animate__slideInRight'
                        this.visibleSlide++
                    }
                }

            }, 16000);
        }
    },

    beforeUnmount() {
        clearInterval(this.polling)
    },

    created(){
        this.contadorCarousel() // inicializa com a pág
    },
}
</script>